import PerfectScrollbar from 'perfect-scrollbar';
import tippy from 'tippy.js';
import toast from 'jquery-toast-plugin';
import Swiper from 'swiper';

if ($('.mypage.message').length > 0) {
    if ($(window).outerWidth() <= 575) {
        // メッセージ表示エリア(.message-wrap .perfect-scroll)のheightはCSSでcalc(100vh-60px-160px-40px)と
        // 100vhからロゴ、入力エリア、一覧に戻るを引いて計算されています。
        // しかしAndroidの場合は100vhにアドレスバーの高さ(実測で55px)が含まれるため、calcの結果は実際に画面に表示されている
        // メッセージ表示エリアの高さよりも55px分大きくなっていて、アドレスバーが表示されている状態ではあふれた55px分は
        // メッセージ入力エリアの後ろに隠れて見えない状態になります。最後のメッセージが見切れるのはこれが原因です。
        // 指でスワイプするなどしてアドレスバーがスクロールして画面から消えればメッセージ表示エリアが55px分拡大するので
        // あふれが起きなくなるのですが、おそらくセキュリティ上の理由でJavaScriptの操作でアドレスバーを見えなくすることが
        // できないので、メッセージ入力エリアのheightを実測値で計算した値で上書きして対処します(つまり55px減らす)。
        // その後はresizeイベントが起きるたびに計算し直して上書きします。
        const resize = () => $('.message-wrap .perfect-scroll').height(window.innerHeight - 60 - 160 - 40);
        window.addEventListener('resize', resize);
        resize();
    }

    const endpoint = '/' + $('#endpoint').val();

    if (Boolean(Number($('#display-message-detail').val()))) {
        // メッセージ詳細表示時 ---
        const currentUrl = window.location.href;
        window.history.replaceState('index', '', endpoint + '/messages');

        if ($(window).outerWidth() <= 575) {
            // SP
            history.pushState('detail', '', currentUrl);
            $('.partners').hide();
            $('.message-wrap').show();

            // ブラウザバックでメンバーの一覧へ戻れるように（スマホのみ）
            $(window).on('popstate', function (event) {
                if (!event.originalEvent.state) return; // 初回アクセス時に再読み込みしてしまう対策
                var strState = event.originalEvent.state;
                if (strState == 'index') {
                    moveChatLists();
                }
            });
        }
    } else {
        // 一覧表示時 ---
        // history state NULLを解除するため
        history.replaceState('index', '', endpoint + '/messages');
    }

    // チャットリスト（相手先リスト）へ戻る
    function moveChatLists() {
        $('.message-wrap').fadeOut();
        $('.back-to-partners').fadeOut('normal', function () {
            $('.partners').fadeIn();
        });
    }

    $(function () {
        tippy('.tippy', {
            arrow: true,
            animation: 'fade',
            content:
                '主な確認事項<br>仕事日時、時給、交通費の有無、服装ルール<br>仕事内容、美容免許、スキル確認、持ち物<br>駐車場の有無',
            allowHTML: true,
        });

        //スクロール中かどうか
        var bScrollingPs = false;
        var $objTimerScrollingMsg;
        $(document).on('ps-scroll-y', function () {
            bScrollingPs = true;
            clearTimeout($objTimerScrollingMsg);
            $objTimerScrollingMsg = setTimeout(function () {
                bScrollingPs = false;
            }, 200);
        });

        // スクロールバー適用
        var sPartnerWrap = '.partners.perfect-scroll';
        var oPsPartners = new PerfectScrollbar(sPartnerWrap);
        var sMessageWrap = '.message-wrap .perfect-scroll';
        var oPsMessageBody = new PerfectScrollbar(sMessageWrap);
        // スクロールイベント付与
        $(sMessageWrap).one('ps-y-reach-start', function () {
            getMessageOld();
        });
        $(sPartnerWrap).one('ps-y-reach-end', function () {
            getMemberOld();
        });

        if (Boolean(Number($('#display-message-detail').val()))) {
            // 最下部までスクロール
            $('.message-wrap .letter-body').scrollTop(
                $('.message-wrap .letter-body')[0].scrollHeight
            );
        }

        // Shift + Enterでも送信可能に
        // keypressだとダイアログが閉じてしまうのでkeydown利用
        $('.input-msg').keydown(function (e) {
            if (e.which == 13 && e.shiftKey) {
                $('.input-area .btn-send').trigger('click');
                // focus外す
                $(this).blur();
                // 改行入力の防止
                return false;
            }
        });

        // ファイル周り ---------------------
        // ファイル添付
        $(document).on('change', '#attachment', function () {
            var file = $(this).prop('files')[0];
            if (typeof file === 'undefined') {
                clearFile();
            } else {
                $('.select-condition').html('選択中');
                $('.select-condition').addClass('select');
                $('.file-clear').addClass('d-inline-block');
                $('.file-name').html(file.name);
            }
        });
        // 選択クリア押下
        $(document).on('click', '.file-clear', function (event) {
            event.preventDefault();
            $('#attachment').replaceWith($('#attachment').clone().val(''));
            clearFile();
        });
        // ファイル選択をクリア
        function clearFile() {
            $('.file-clear').removeClass('d-inline-block');
            $('.select-condition').html('');
            $('.select-condition').removeClass('select');
            $('.file-name').html('');
        }
        // ---------------------

        // 送信せずに遷移する場合
        var bUnsend = false;
        $(window).bind('beforeunload', function (e) {
            // 確認メッセージに表示させたい文字列
            if (bUnsend) {
                return '送信されていないメッセージがありますが、移動してもよろしいですか？';
            }
        });
        // 入力値変わったら
        $('.input-msg').on('change', function () {
            if ($.trim($('.input-msg').val()) != '') {
                bUnsend = true;
            } else {
                bUnsend = false;
            }
        });

        // メンバーの一覧へ戻る押下時
        $(document).on('click', '.back-to-partners', function (event) {
            event.preventDefault();
            if (window.history && window.history.pushState) {
                window.history.back();
            } else {
                moveChatLists();
            }
        });

        // 相手リスト押下時
        $(document).on('click', '.partners .member-link', function (event) {
            event.preventDefault();
            // 入力欄表示
            $('.input-area .btn-send').prop('disabled', false);
            getMessage($(this));
        });

        // メンバー読み込み
        function getMemberOld() {
            // イベントの一時無効化
            // 1度発火すると終わるので、都度オフ→オンにする
            $(sPartnerWrap).off('ps-y-reach-end');
            // $(document).off('ps-y-reach-end');

            // スクロール位置
            var iPosition = $('.partners').scrollTop();

            // 相手リストで最下部までスクロールしたら
            if (
                iPosition + $('.partners').outerHeight() == $('.partners')[0].scrollHeight &&
                $('.room-full').length == 0
            ) {
                // スクロール可をストップ
                oPsPartners.destroy();
                // $(".partners").prepend(sLoadingHtml).hide().fadeIn(70);
                var iOffset = $('.partners ul li').length;
                oJqxhr = $.ajax({
                    url: endpoint + '/messages/getRoomList/' + iOffset,
                    type: 'get',
                    dataType: 'json',
                })
                    .done(function (data) {
                        if (data.iResponseCode == 200) {
                            $(data.html).appendTo('.partners ul');
                            // 重複を削除
                            var iIds = [];
                            $('.partners .member-link').each(function (i, oElem) {
                                iIds.push($(oElem).data('id'));
                            });
                            var aDuplicatedIds = iIds.filter(function (x, i, oElem) {
                                return oElem.indexOf(x) === i && i !== oElem.lastIndexOf(x);
                            });
                            $.each(aDuplicatedIds, function (i, iValue) {
                                $('.partners .member-link[data-id=' + iValue + ']:last').remove();
                            });
                        }
                    })
                    .fail(function (data, sStatus, errorThrown) {
                        // 中断時は何もしない
                        if (sStatus === 'abort') {
                            return;
                        }
                        $.toast({
                            heading: 'データの読み込みに失敗しました',
                            text: 'お手数ですが、再度お試しください。',
                            showHideTransition: 'slide',
                            icon: 'error',
                            position: 'bottom-right',
                            hideAfter: 6000,
                        });
                    })
                    .always(function (data) {
                        // 再定義
                        oPsPartners = new PerfectScrollbar(sPartnerWrap);
                        // スクロール位置再現
                        $('.partners').scrollTop(iPosition);
                        $('#loading-animation').fadeOut(70, function () {
                            $(this).remove();
                        });
                        if ($('.member-full').length == 0) {
                            // スクロールエンドイベント再開
                            $(sPartnerWrap).one('ps-y-reach-end', function () {
                                getMemberOld();
                            });
                        }
                    });
            } else if ($('.room-full').length == 0) {
                // スクロールエンドイベント再開
                $(sPartnerWrap).one('ps-y-reach-end', function () {
                    getMemberOld();
                });
            }
        }

        // 送信中フラグ
        var bSending = false;

        // 送信ボタン押下時
        $(document).on('click', '.input-area .btn-send', function (event) {
            event.preventDefault();
            if (bSending) {
                return;
            }
            bSending = true;
            var sBody = $.trim($('.input-msg').val());
            // var bNoAttachment = $("#attachment").prop("files")[0] === undefined;
            if (sBody == '') {
                $.toast({
                    heading: 'メッセージを入力してください',
                    text: '空文では送信できません。',
                    showHideTransition: 'slide',
                    icon: 'error',
                    position: 'bottom-right',
                    hideAfter: 6000,
                });
                $('.input-msg').focus();
                bSending = false;
                return;
            }
            /*
            if (sBody.match(/^[\x20-\x7e]*$/) && bNoAttachment){
                $.toast({
                    heading: '日本語を含めた形で送信してください',
                    text: 'セキュリティの都合上、半角英数記号のみのメッセージは送信できません。お手数ですが日本語を含めた形で送信をお願いします。',
                    showHideTransition: 'slide',
                    icon: 'error',
                    position: 'bottom-right',
                    hideAfter: 6000
                });
                $(".input-msg").focus();
                bSending = false;
                return;
            }
            */
            // 相手が選択されてなかったら終了
            if ($('.partners .member-link.active').length == 0) {
                bSending = false;
                return;
            }
            var iPartnerUserId = $('.partners .member-link.active').attr('data-id');
            var iMessageLength = $('.message-wrap .letter-body .message-id').length;
            var iLastMessageId = 0;
            if (iMessageLength > 0) {
                iLastMessageId = $('.message-wrap .letter-body .message-id')
                    .eq(iLastMessageId - 1)
                    .val();
            }
            var formData = new FormData();
            // if ($("#attachment").prop("files")[0] !== undefined && $("#attachment").prop("files")[0] !== null){
            //     formData.append("attachment", $("#attachment").prop("files")[0]);
            // }
            formData.append('body', sBody);
            // $(".message-wrap").prepend(sLoadingHtml).hide().fadeIn(70);
            $.ajax({
                headers: {
                    'X-CSRF-TOKEN': $('input[name="_token"]').val(),
                },
                url: endpoint + '/messages/send/' + iPartnerUserId + '/' + iLastMessageId,
                data: formData,
                type: 'POST',
                // Ajaxがdataを整形しない指定
                processData: false,
                // contentTypeもfalseに指定
                contentType: false,
                dataType: 'json',
            })
                .done(function (data) {
                    if (data.iResponseCode == 200) {
                        $('.message-wrap .letter-body').append(data.html);
                        $('.input-msg').val('');
                        // ファイル参照クリア
                        $('.file-clear').trigger('click');
                        // 最下部までスクロールさせる
                        $('.message-wrap .letter-body').scrollTop(
                            $('.message-wrap .letter-body')[0].scrollHeight
                        );
                        // メッセージ欄へフォーカス
                        $('.input-msg').focus();
                        bUnsend = false;
                    } else if (data.iResponseCode == 400) {
                        $.toast({
                            heading: 'データの読み込みに失敗しました',
                            text: data.sMessage,
                            showHideTransition: 'slide',
                            icon: 'error',
                            position: 'bottom-right',
                            hideAfter: 6000,
                        });
                    }
                })
                .fail(function (data) {
                    if (data.status == 422) {
                        $.toast({
                            heading: 'データの読み込みに失敗しました',
                            text: data.responseJSON.sErrorMessage,
                            showHideTransition: 'slide',
                            icon: 'error',
                            position: 'bottom-right',
                            hideAfter: 6000,
                        });
                    } else {
                        $.toast({
                            heading: 'データの読み込みに失敗しました',
                            text: data.sMessage,
                            showHideTransition: 'slide',
                            icon: 'error',
                            position: 'bottom-right',
                            hideAfter: 6000,
                        });
                    }
                })
                .always(function (data) {
                    $('#loading-animation').fadeOut(70, function () {
                        $(this).remove();
                    });
                    bSending = false;
                });
        });

        // ajaxリクエスト中断用：oJqxhrオブジェクト
        var oJqxhr;
        // メッセージ取得（リスト押下イベント関数）
        function getMessage($oMemberLink) {
            // 動作中は発火させない
            if ($oMemberLink.attr('data-clickable') !== 'true') {
                return;
            }
            $oMemberLink.attr('data-clickable', 'false');
            $('#loading-animation').fadeOut(70, function () {
                $(this).remove();
            });
            // リクエスト中だったら中断
            if (oJqxhr) {
                oJqxhr.abort();
            }

            $('.partners .member-link').removeClass('active');
            $oMemberLink.addClass('active');

            var iRoomId = $oMemberLink.attr('data-id');

            // スマホ・タブレット
            if ($(window).outerWidth() <= 575) {
                $('.partners').fadeOut('normal', function () {
                    // この後のコードにおいてAJAX応答のalways()でも最下部までスクロールさせていますが、fadeInが完了する前に
                    // 応答が返ってくるとdisplay:noneの状態でscrollHeight = 0を取得してしまい結果として一番上が表示されます。
                    // これを防ぐためにfaceInが終わった後にもスクロールをさせます。
                    $('.message-wrap').fadeIn(400, () => {
                        // 最下部までスクロールさせる
                        $('.message-wrap .letter-body').scrollTop(
                            $('.message-wrap .letter-body')[0].scrollHeight
                        );
                    });
                    $('.back-to-partners').fadeIn();
                    if (window.history && window.history.pushState) {
                        history.pushState('detail', '', endpoint + '/messages/' + iRoomId);
                        // ブラウザバックでメンバーの一覧へ戻る（スマホのみ）
                        $(window).on('popstate', function (event) {
                            if (!event.originalEvent.state) return; // 初回アクセス時に再読み込みしてしまう対策
                            var strState = event.originalEvent.state;
                            if (strState == 'index') {
                                moveChatLists();
                            }
                        });
                    }
                });
            }

            // 破棄してスクロールストップ
            oPsMessageBody.destroy();

            $('.message-wrap .letter-body').html('');
            // $(".message-wrap .letter-body").prepend(sLoadingHtml).hide().fadeIn(70);
            oJqxhr = $.ajax({
                url: endpoint + '/messages/getMessage/' + iRoomId,
                type: 'GET',
                dataType: 'json',
            })
                .done(function (data) {
                    if (data.iResponseCode == 200) {
                        // スクロールトップイベントの一時無効化
                        $(sMessageWrap).off('ps-y-reach-start');
                        // $(document).off('ps-y-reach-start');

                        $('.message-wrap .letter-body').html(data.top + data.html + data.buttom + data.reload);
                        // 未読マーク除去
                        $oMemberLink.find('.unread-mark').remove();
                        // 未読数更新
                        if (data.unread_count < 1) {
                            $('.messege-icon').remove();
                            var msgButton = document.getElementsByClassName('mypage-mess')[0];
                            msgButton.classList.remove('icon');
                        } else {
                            $('.messege-icon').html(data.unread_count);
                        }
                    }
                })
                .fail(function (data, sStatus) {
                    // 中断時は何もしない
                    if (sStatus === 'abort') {
                        return;
                    }
                    $.toast({
                        heading: 'データの読み込みに失敗しました',
                        text: 'お手数ですが、再度お試しください。',
                        showHideTransition: 'slide',
                        icon: 'error',
                        position: 'bottom-right',
                        hideAfter: 6000,
                    });
                })
                .always(function (data) {
                    // 再定義
                    oPsMessageBody = new PerfectScrollbar(sMessageWrap);
                    // 最下部までスクロールさせる
                    $('.message-wrap .letter-body').scrollTop(
                        $('.message-wrap .letter-body')[0].scrollHeight
                    );

                    $('#loading-animation').fadeOut(70, function () {
                        $(this).remove();
                    });
                    // スクロールトップイベント付与
                    $(sMessageWrap).one('ps-y-reach-start', function () {
                        getMessageOld();
                    });
                    // $(document).one('ps-y-reach-start', function(){getMessageOld()});
                    // 発火再開
                    $oMemberLink.attr('data-clickable', 'true');
                });
        }

        // 古いメッセージ取得
        function getMessageOld() {
            // リクエスト中だったら中断
            if (oJqxhr) {
                oJqxhr.abort();
            }
            // スクロールトップイベントの一時無効化
            // 1度発火すると終わるので、都度オフ→オンにする
            $(sMessageWrap).off('ps-y-reach-start');
            // メッセージ欄で最上部にスクロールしたら
            var iDisplayNumber = $('#message-display-number').val();
            if (
                $('.message-wrap .letter-body').scrollTop() == 0 &&
                $('.message-wrap .letter-body .box').length >= iDisplayNumber &&
                $('.message-wrap .letter-body .box .msg-full').length == 0
            ) {
                // メッセージ枠の高さ（スクロール位置維持用）
                var iHeight = $('.message-wrap .letter-body')[0].scrollHeight;
                var iRoomId = $('.partners .member-link.active').attr('data-id');
                var iMessageIdFirst = $('.message-wrap .letter-body .message-id').first().val();
                // $(".message-wrap .letter-body").prepend(sLoadingHtml).hide().fadeIn(70);
                oJqxhr = $.ajax({
                    url: endpoint + '/messages/getMessageOld/' + iRoomId + '/' + iMessageIdFirst,
                    type: 'GET',
                    dataType: 'json',
                })
                    .done(function (data) {
                        if (data.iResponseCode == 200) {
                            $(data.html).prependTo('.message-wrap .letter-body');
                        }
                    })
                    .fail(function (data, sStatus) {
                        // 中断時は何もしない
                        if (sStatus === 'abort') {
                            return;
                        }
                        $.toast({
                            heading: 'データの読み込みに失敗しました.',
                            text: 'お手数ですが、再度お試しください。',
                            showHideTransition: 'slide',
                            icon: 'error',
                            position: 'bottom-right',
                            hideAfter: 6000,
                        });
                    })
                    .always(function (data) {
                        // スクロール位置再現
                        $('.message-wrap .letter-body').scrollTop(
                            $('.message-wrap .letter-body')[0].scrollHeight - iHeight
                        );
                        $('#loading-animation').fadeOut(70, function () {
                            $(this).remove();
                        });
                        if ($('.msg-full').length == 0) {
                            // スクロールトップイベント再開
                            $(sMessageWrap).one('ps-y-reach-start', function () {
                                getMessageOld();
                            });
                        }
                    });
            } else if ($('.msg-full').length == 0) {
                // スクロールトップイベント再開
                $(sMessageWrap).one('ps-y-reach-start', function () {
                    getMessageOld();
                });
            }
        }

        $(window).on('load', function () {
            setInputMsgPlaceholder();
        });
        // リサイズ操作終了後
        var timer = false;
        $(window).resize(function () {
            if (timer !== false) {
                clearTimeout(timer);
            }
            timer = setTimeout(function () {
                setInputMsgPlaceholder();
                setDisplay();
            }, 200);
        });

        // placeholderを設定
        function setInputMsgPlaceholder() {
            if ($(window).outerWidth() <= 767) {
                $('.input-msg').attr(
                    'placeholder',
                    'メッセージは失礼のないように丁寧な文章を心がけて下さい。（最大1000文字）\n想定している仕事内容や持ち物、服装のルール、疑問は必ず確認するようにして下さい。\n間違いがないように日時や時給、交通費の有無についても再確認を行って下さい。'
                );
            }
        }

        // 表示切り替え
        function setDisplay() {
            if (576 <= $(window).outerWidth()) {
                // PC
                $('.partners').show();
                $('.message-wrap').show();
            } else {
                // SP
                if ($('.partners').css('display') == 'block') {
                    $('.message-wrap').hide();
                }
            }
        }

        // お店情報のモーダルを開いたら
        $(document).on('shown.bs.modal', '#shopModalCenter', function () {
            let storeSwiper = new Swiper(".message-modal-swiper", {
                slidesPerView: 1.2,
                spaceBetween: 10,
                centeredSlides: true,
                loop: true,
                /*
                // モーダル内だと効かない模様
                // navigation: {
                //     nextEl: ".swiper-button-next",
                //     prevEl: ".swiper-button-prev"
                // },
                */
            });
            // navigationオプションが効かないので以下でメソッド設定
            $(document).on('click', '.swiper-button-next', function () {
                storeSwiper.slideNext();
            });
            $(document).on('click', '.swiper-button-prev', function () {
                storeSwiper.slidePrev();
            });
        });
    });
}
